import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const PortalsInUseContainer = styled.div`
  display: flex;
  justify-content: end;
`
